import { SliderFilledTrack, type SliderTrackProps } from '@chakra-ui/react';

export type UiSliderFilledTrackProps = SliderTrackProps;

export const UiSliderFilledTrack = SliderFilledTrack;
